module.exports = __webpack_public_path__ + "static/img/sub_page_banner_3.5a780a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_3.jpg
// module id = TyJ+
// module chunks = 0